import { combineReducers } from 'redux';

import cart from './cart';
import favorites from './favorite-products';
import notification from './notification';
import order from './order';
import previousOrders from './previous-orders';
import productDetails from './product-details';
import scheduledOrdering from './scheduled-ordering';
import selectedPayment from './selected-payment';
import selectedReloadSourceId from './selected-reload-source-id';
import selectedStore from './selected-store';
import similarItems from './similar-items';
import variables from './variables';
import preOrderEstimate from './pre-order-pickup-estimate';
import orderPickupTime from './order-pickup-time';
import postStoreSelectionReturnUrl from './post-store-selection-return-url';
import pricingRules from './pricing-rules';
import pricingByStore from './pricing-by-store';

export default combineReducers({
  cart,
  favorites,
  notification,
  order,
  orderPickupTime,
  postStoreSelectionReturnUrl,
  preOrderEstimate,
  previousOrders,
  productDetails,
  scheduledOrdering,
  selectedPayment,
  selectedReloadSourceId,
  selectedStore,
  similarItems,
  variables,
  pricingRules,
  pricingByStore,
});
